<template>
  <div class="recommendation EOPPBlock">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="representativeHeader">
      <span class="representativeTitle">INDICAÇÃO</span>
    </div>

    <div class="content-wrapper">
      <p style="margin-bottom: 2rem;">
        Vocês tem alguma outra Organização Estudantil da sua Universidade para
        indicar? Se sim, preencha os campos abaixo.
      </p>

      <!-- OE - recommendation name -->
      <b-field
        :label="$parent.oe.recommendationName ? 'Nome da OE' : ''"
        label-position="on-border"
      >
        <b-input
          v-model="$parent.oe.recommendationName"
          placeholder="Nome da OE"
        ></b-input>
      </b-field>

      <!-- OE - recommendation contact -->
      <b-field
        :label="
          $parent.oe.recommendationContact ? 'Contato de algum membro' : ''
        "
        label-position="on-border"
      >
        <b-input
          v-model="$parent.oe.recommendationContact"
          placeholder="Contato de algum membro"
        ></b-input>
      </b-field>

      <!-- OE - recommendation contact -->
      <b-field
        :label="$parent.oe.recommendationInstagram ? 'Instagram da OE' : ''"
        label-position="on-border"
      >
        <b-input
          v-model="$parent.oe.recommendationInstagram"
          placeholder="Instagram da OE"
        ></b-input>
      </b-field>

      <button
        class="button is-primary is-rounded"
        style="margin-left: auto; display: block;"
        @click="sendRecommendation"
        :disabled="!pendencies"
      >
        Enviar
      </button>
    </div>
  </div>
</template>

<script>
import { commom } from "../../../mixins/commom";

export default {
  name: "Recommendation",

  mixins: [commom],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    sendRecommendation() {
      this.isLoading = true;
      this.$store
        .dispatch("sendRecommendation", {
          name: this.$parent.oe.recommendationName,
          contact: this.$parent.oe.recommendationContact,
          instagram: this.$parent.oe.recommendationInstagram
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$parent.oe.recommendationName = "";
            this.$parent.oe.recommendationContact = "";
            this.$parent.oe.recommendationInstagram = "";
            this.$buefy.toast.open({
              message: "Recomendação enviada!",
              type: "is-success",
              position: "is-bottom"
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    pendencies() {
      return (
        this.$parent.oe.recommendationName &&
        (this.$parent.oe.recommendationContact ||
          this.$parent.oe.recommendationInstagram)
      );
    }
  }
};
</script>

<style scoped>
.recommendation {
  margin-top: 0.5rem;
}
.representativeHeader {
  background: rgb(2, 209, 168);
  background: linear-gradient(
    90deg,
    rgba(2, 209, 168, 1) 0%,
    rgba(95, 255, 223, 1) 100%,
    rgba(60, 247, 210, 1) 100%
  );
  border: transparent;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
}
.representativeTitle {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 2rem;
  margin-top: 0.5rem;
}
.content-wrapper {
  padding: 2rem;
}
</style>
